import { GenericService } from './generic.service';
export class OrganisationPermissionService extends GenericService {
    constructor(organisationId) {
        super(`v1/organisations/${organisationId}/permissions`);
    }
}
